export default __webpack_public_path__ + "static/media/ribbon_type.4e4c448b.jpeg";